import { observable } from 'mobx';
import { AuthenticationModel } from '../models';
import { IMindMeAccountDetails } from '../interfaces';

class AuthService {
  public authData = new AuthenticationModel();
  @observable public isLoggedIn: boolean = this.authData.isLoggedIn;
  public fromPaymentSystem: boolean = false;
  public prefixRoute: string = '/app/';
  public mindmeAccountDetails: IMindMeAccountDetails | null = null;
  public hideLeftMenuFlag: boolean = false;
  public hideHeaderBarFlag: boolean = false;
  public lastRoute: string = '';
  public mindMeRoute: string = '';
  isPrimarySubAccount: boolean = false;
  hasLibraryManagePermissions: boolean = false;
  shortUniqueId: string = '';

  setMindMeRoute(value: string) {
    this.mindMeRoute = value;
  }

  setLastRoute(value: string) {
    this.lastRoute = value;
  }

  setLoginState(value: boolean) {
    this.isLoggedIn = value;
  }

  setAuthData(
    accountId: string,
    shortUniqueId: string = '',
    isPrimarySubAccount: boolean = false,
    hasLibraryManagePermissions: boolean = false
  ) {
    this.authData.accountId = accountId;
    this.shortUniqueId = shortUniqueId;
    this.isPrimarySubAccount = isPrimarySubAccount;
    this.hasLibraryManagePermissions = hasLibraryManagePermissions;
    this.setLoginState(true);
  }

  setLogOutState() {
    this.setLoginState(false);
    this.authData.removeAuthData();
  }

  setFromPaymentSystem(value: boolean) {
    this.fromPaymentSystem = value;
    // Local-dev convenience ONLY: seed a fixed test account so the payment app is usable when
    // run standalone (not embedded in Main_Web2, so no real accountId arrives via postMessage).
    // Gated on NODE_ENV === 'development', which is true only while a developer runs the local
    // dev server - every built bundle (staging AND production) is NODE_ENV 'production', so this
    // never fires there. REACT_APP_TEST_ACCOUNT_ID is set in all .env files, so gating on the
    // var's presence alone would silently impersonate this account in production.
    if (
      process.env.NODE_ENV === 'development' &&
      !this.authData.accountId &&
      this.fromPaymentSystem &&
      process.env.REACT_APP_TEST_ACCOUNT_ID
    ) {
      this.setAuthData(process.env.REACT_APP_TEST_ACCOUNT_ID);
    }
  }

  setPrefixRoute(value: string) {
    this.prefixRoute = value;
  }

  setMindmeAccountDetails(data: IMindMeAccountDetails) {
    this.mindmeAccountDetails = data;
  }

  setHideLeftMenu(value: boolean) {
    this.hideLeftMenuFlag = value;
  }

  get hasAccount(): boolean {
    return this.authData.accountId ? true : false;
  }

  get hideLeftMenu(): boolean {
    return this.hideLeftMenuFlag || !this.hasAccount;
  }

  setHideHeaderBar(value: boolean) {
    this.hideHeaderBarFlag = value;
  }

  get hideHeaderBar(): boolean {
    return this.hideHeaderBarFlag || !this.hasAccount;
  }

  get isMerchantAccountsRoute(): boolean {
    return window.location.pathname.includes(`${this.prefixRoute}merchant-accounts`);
  }

  get isMindMeContactRoute(): boolean {
    return this.mindMeRoute.includes(`${this.prefixRoute}find-account/contact`);
  }

  get getMindMeContactId(): string {
    if (!this.isMindMeContactRoute) {
      return '';
    }
    const pathSegments = this.mindMeRoute.split('/');
    return pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : '';
  }
}
export default new AuthService();
